// extracted by mini-css-extract-plugin
export default {"recipeImage":"RecipeImage_recipeImage__DrdLM","recipeImagePlaceholder":"RecipeImage_recipeImagePlaceholder__BLzmv","recipeImageIcon":"RecipeImage_recipeImageIcon__Qifap"};